<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <Title>基础信息</Title>
      <el-descriptions class="mb20">
        <el-descriptions-item label="订单编号">{{info.orderNo}}</el-descriptions-item>
        <el-descriptions-item label="预约类型">{{info.type==10?'线下':'线上'}}预约</el-descriptions-item>
        <el-descriptions-item label="服务类型">{{info.serviceItems}}</el-descriptions-item>
        <el-descriptions-item label="地址">{{info.provinceName}}{{info.cityName}}{{info.districtName}}{{info.address}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{info.message}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.status |setStatus(info)}}</el-descriptions-item>
        <el-descriptions-item label="提交预约时间">{{info.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="预约时间" v-if="[20,30].includes(info.status)">{{info.startTime}}--{{info.endTime?info.endTime.split(' ')[1]:''}}</el-descriptions-item>
        <el-descriptions-item label="完成时间" v-if="info.status==40">{{info.completeTime}}</el-descriptions-item>
        <el-descriptions-item label="取消时间" v-if="info.status==50">{{info.cancelTime}}</el-descriptions-item>
        <el-descriptions-item label="取消人" v-if="info.status==50">{{info.cancelUserName}} {{info.cancelUserMobile}}【{{info.cancelType==10?'客户':info.cancelType==11?'技术老师':'平台'}}】</el-descriptions-item>
        <el-descriptions-item label="取消原因" v-if="info.status==50">{{info.cancelReason}}</el-descriptions-item>
      </el-descriptions>
      <Title>预约用户信息</Title>
      <el-descriptions class="mb20">
        <el-descriptions-item label="用户姓名">{{info.customerName}}</el-descriptions-item>
        <el-descriptions-item label="用户身份">{{info.customerLevelName}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{info.customerPho}}</el-descriptions-item>
      </el-descriptions>
      <Title>技术老师信息</Title>
      <el-descriptions class="mb20">
        <el-descriptions-item label="技术老师姓名">{{info.technicianInfoRealName}}</el-descriptions-item>
        <el-descriptions-item label="技术老师身份">{{info.technicianInfoLevelName}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{info.technicianInfoMobile}}</el-descriptions-item>
      </el-descriptions>
      <Title v-if="[40,30].includes(info.status)">技术老师签到信息</Title>
      <el-descriptions :column="12" class="mb20" v-if="[40,30].includes(info.status)">
        <el-descriptions-item label="签到时间" :span="4">{{info.signInTime}}</el-descriptions-item>
        <el-descriptions-item label="签到地址">{{info.signInVO.address}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="12" class="mb20" v-if="[40,30].includes(info.status)">
        <el-descriptions-item label="签到备注" :span="12">
          <div class="flex-col">
            <div class="w-100">{{info.signInVO.remark}}</div>
            <div class="flexs mt10" v-if="info.signInVO.imageUrls">
              <el-image style="width: 160px; height: 100px;margin: 5px" v-for="(item, index) in info.signInVO.imageUrls.split(',')" :key="item || index" :src="item" :preview-src-list="[item]"></el-image>
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <Title class="mt20" v-if="info.status==30 && info.isComment">服务评价</Title>
      <el-descriptions class="mb20" :column="3" v-if="info.status==30 && info.isComment">
        <el-descriptions-item label="服务态度">
          <el-rate v-model="info.commentVO.serviceScore" disabled :colors="['#60B7DC','#60B7DC','#60B7DC']">
          </el-rate>
          <span>【{{info.commentVO.serviceScore | setGrade}}】</span>
        </el-descriptions-item>
        <el-descriptions-item label="专业水平">
          <el-rate v-model="info.commentVO.professionalScore" disabled :colors="['#60B7DC','#60B7DC','#60B7DC']">
          </el-rate>
          <span>【{{info.commentVO.professionalScore | setGrade}}】</span>
        </el-descriptions-item>
        <el-descriptions-item label="问题解决率">
          <el-rate v-model="info.commentVO.efficiencyScore" disabled :colors="['#60B7DC','#60B7DC','#60B7DC']">
          </el-rate>
          <span>【{{info.commentVO.efficiencyScore | setGrade}}】</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions class="mb20" :column="2" v-if="info.status==30 && info.isComment">
        <el-descriptions-item label="培训方式">{{info.commentVO.tag}}</el-descriptions-item>
        <el-descriptions-item label="请问一下带教老师是否给你做案例复盘，复盘方式是怎样的呢？">{{info.commentVO.question1}}</el-descriptions-item>
        <el-descriptions-item label="请问技术老师是否给你做过项目落地培训？">{{info.commentVO.question2}}</el-descriptions-item>
        <el-descriptions-item label="请问技术老师是否给你做转化通关？">{{info.commentVO.question3}}</el-descriptions-item>
        <el-descriptions-item label="您是否学会">{{info.commentVO.question4}}</el-descriptions-item>
        <el-descriptions-item label="本次服务通关内容">{{info.commentVO.content}}</el-descriptions-item>
      </el-descriptions>
      <Title class="mt20" v-if="[10,20,30].includes(info.status)">调整记录</Title>
      <el-timeline reverse class="mb20">
        <!-- <el-timeline-item icon="el-icon-time" v-for="(item,index) in list.filter(i=>i.type!=30)" :key="item.id" size="large">
          <div class="w-100 flex-col" >
            <sapn>调整后的预约时间：{{item.content.split(' ')[0]}} {{item.content.split(' ')[1]}}-{{item.content.split(' ')[2]}}</sapn>
            <span class="font12 c-8F8E8E mt10">原本预约时间为：{{list[index+1].content.split(' ')[0]}} {{list[index+1].content.split(' ')[1]}}-{{list[index+1].content.split(' ')[2]}}</span>
            <div class="remark-box mt10 c-8F8E8E" v-if="item.remark">
              备注：{{item.remark}}
            </div>
            <span class="font12 c-8F8E8E mt10">{{item.createdTime}}</span>
          </div>
        </el-timeline-item> -->
        <el-timeline-item icon="el-icon-time" v-for="(item,index) in list" :key="index" size="large">
          <div class="w-100 flex-col" v-if="[10,20,30].includes(info.status)">
            <sapn>{{item.type === 42?'调整后的带教老师：':'调整后的预约时间：'}} {{item.content}}</sapn>
            <span class="font12 c-8F8E8E mt10">{{item.type === 42?'原本带教老师：':'原本预约时间为：'}} {{item.prevContent}}</span>
            <div class="remark-box mt10 c-8F8E8E" v-if="item.remark">
              {{item.type === 42?'转单原因：':'备注：'}} {{item.remark}}
            </div>
            <span class="font12 c-8F8E8E mt10">{{item.createdTime}}</span>
          </div>
        </el-timeline-item>
      </el-timeline>

    </el-card>
  </div>
</template>

<script>
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
export default {
  props: ['rowId'],
  data() {
    return {
      activeName: 'first',
      list: [],
      form: null,
      value: 4,
      // technicalState: 1,
      shareData: null,
      info: {}
    }
  },
  filters: {
    setStatus(val, info) {
      switch (val) {
        case 10:
          return "待排期";
        case 20:
          return "待服务";
        case 30:
          return info && info.isComment ? "已评论" : "待评论";
        case 40:
          return info && info.isComment ? "已评论" : "已完成";
        case 50:
          return "已取消";
        default:
          return val;
      }
    },
    setGrade(val) {
      switch (val) {
        case 5:
          return "非常好";
        case 4:
          return "好";
        case 3:
          return "一般";
        case 2:
          return "差";
        case 1:
          return "非常差";
        default:
          return val;
      }
    }
  },
  async created() {
    // console.log(this.rowId, 'id00000')
    await this.getDetail()


    // this.handleShow()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    async getDetail() {
      const {
        data
      } = await technicianServiceOrderApi.fetchById(this.rowId)
      this.info = data
      if ([10, 20, 30].includes(this.info.status)) {
        this.getRecords()
      }
      console.log('详情data', data)
    },
    async getRecords() {
      const {
        data
      } = await technicianServiceOrderApi.getServiceOrderList({
        serviceOrderId: this.rowId
      })
      this.list = data
      console.log('记录: ', data);
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }

  }

}
</script>

<style lang="scss" scoped>
.remark-box {
  background: #d9d9d94d;
  padding: 10px;
}

.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;

  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}

.title-box {
  margin: 10px 24px 15px 0;

  &::after {
    content: '';
    display: table;
    clear: both;
  }

  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }

  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }

  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}

.tab-box {
  margin-bottom: 40px;

  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;

    &.active {
      color: #5dbde7;
    }
  }
}
</style>
